
const myContributionOnboard = {
    "measures": [
        "Contribution.client_count"
    ],
    "order": {
        "Contribution.Onboarded_date": "asc"
    },
    "dimensions": [
        "Contribution.Onboarded_date",
        "Contribution.onboarded_day_name"
    ],

}

const myContributionCase = {
    "measures": [
        "Contribution.total_case_count"
    ],
    "timeDimensions": [
        {
            "dimension": "Contribution.Date"
        }
    ],
    "order": {
        "Contribution.Date": "asc"
    },
    "dimensions": [
        "Contribution.Date",
        "Contribution.day_name",
        //   "Contribution.agent_name"
    ],

}

const myIncentiveAmount = {
    "measures": [
        "Contribution.incentive_amount"
    ],
    "timeDimensions": [
        {
            "dimension": "Contribution.Date"
        }
    ],
    "order": {
        "Contribution.Date": "asc"
    },
    "dimensions": [
        "Contribution.Date",
        "Contribution.day_name"
        //   "Contribution.agent_name"
    ],

}




export const handleQueryMyOnboardCount = (
    name, startDate, endDate, contribution, modality,teamName
) => {
    let filters = [];
    let tableName = "Contribution";

    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "afterDate",
            "values": [
                startDate
            ]
        }
    )

    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "beforeDate",
            "values": [
                endDate
            ]
        }
    )
    if (contribution === 'my') {
        filters.push({
            member: tableName + ".agent_name",
            operator: "contains",
            values: [name],
        });
    }

    if (modality?.length > 0 && modality?.length <= 3) {
        filters.push({
            member: tableName + ".modality",
            operator: "equals",
            values: modality,
        });
    }

    if(contribution !=='my' && teamName!=='All'){
        filters.push({
            member: tableName + ".agent_name",
            operator: "contains",
            values: [teamName],
        });
    }



    if (filters?.length) {
        return { ...myContributionOnboard, filters };
    }
    return myContributionOnboard;
};


export const handleQueryMyCaseCount = (
    name, startDate, endDate, contribution, modality,teamName
) => {

    let filters = [];
    let tableName = "Contribution";

    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "afterDate",
            "values": [
                startDate
            ]
        }
    )

    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "beforeDate",
            "values": [
                endDate
            ]
        }
    )

    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "afterDate",
            "values": [
                '2024-03-31'
            ]
        }
    )

    if (contribution === 'my') {
        filters.push({
            member: tableName + ".agent_name",
            operator: "contains",
            values: [name],
        });
    }

    if (modality?.length > 0 && modality?.length <= 3) {
        filters.push({
            member: tableName + ".modality",
            operator: "equals",
            values: modality,
        });
    }


    if(contribution !=='my' && teamName!=='All'){
        filters.push({
            member: tableName + ".agent_name",
            operator: "contains",
            values: [teamName],
        });
    }



    if (filters?.length) {
        return { ...myContributionCase, filters };
    }
    return myContributionCase;

};



export const handleQueryMyOverallCaseCount = (
    name, startDate, endDate, contribution, modality
) => {

    let filters = [];
    let tableName = "Contribution";

    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "afterDate",
            "values": [
                startDate
            ]
        }
    )

    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "beforeDate",
            "values": [
                endDate
            ]
        }
    )

    if (contribution === 'my') {
        filters.push({
            member: tableName + ".agent_name",
            operator: "contains",
            values: [name],
        });
    }

    if (modality?.length > 0 && modality?.length <= 3) {
        filters.push({
            member: tableName + ".modality",
            operator: "equals",
            values: modality,
        });
    }



    if (filters?.length) {
        return { ...myContributionCase, filters };
    }
    return myContributionCase;

};






export const handleMyIncentiveAmount = (
    name, startDate, endDate, contribution, modality, teamName
) => {

    let filters = [];
    let tableName = "Contribution";

    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "afterDate",
            "values": [
                '2024-03-31'
            ]
        }
    )

    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "afterDate",
            "values": [
                startDate
            ]
        }
    )

    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "beforeDate",
            "values": [
                endDate
            ]
        }
    )

    if (contribution === 'my') {
        filters.push({
            member: tableName + ".agent_name",
            operator: "contains",
            values: [name],
        });
    }

    if (modality?.length > 0 && modality?.length <= 3) {
        filters.push({
            member: tableName + ".modality",
            operator: "equals",
            values: modality,
        });
    }

    if(contribution !=='my' && teamName!=='All'){
        filters.push({
            member: tableName + ".agent_name",
            operator: "contains",
            values: [teamName],
        });
    }




    if (filters?.length) {
        return { ...myIncentiveAmount, filters };
    }
    return myIncentiveAmount;

};


const marketQueryState = {
    "order": {
        "m_dashboard.state": "asc"
    },
    "measures": [
        "m_dashboard.lead_count"
    ],
    "timeDimensions": [
        {
            "dimension": "m_dashboard.created_at"
        }
    ],
    "filters": [
        {
            "member": "m_dashboard.Onboarded_at",
            "operator": "beforeDate",
            "values": [
                "2024-04-01"
            ]
        }
    ],
    "dimensions": [
        "m_dashboard.state",
        "m_dashboard.city"
    ]
}


export const handleStateProspectQuery = (name) => {
    return marketQueryState
}

const marketQueryOnboard = {
    "measures": [
        "Contribution.client_count"
    ],
    "order": {
        "Contribution.Onboarded_date": "asc"
    },
    "dimensions": [
        "Contribution.state",
        "Contribution.city",
        "Contribution.Onboarded_date",
        "Contribution.onboarded_day_name"
    ],
}

const myStateCaseCount = {
    "measures": [
        "Contribution.total_case_count"
    ],
    "timeDimensions": [
        {
            "dimension": "Contribution.Date"
        }
    ],
    "order": {
        "Contribution.Date": "asc"
    },
    "dimensions": [
        "Contribution.state",
        "Contribution.city",
        "Contribution.Date",
        "Contribution.day_name",
        //   "Contribution.agent_name"
    ],

}

export const handleStateOnboardQuery = (name, startDate, endDate, dateMonthRadio) => {
    let filters = [];
    let tableName = "Contribution";

    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "afterDate",
            "values": [
                '2024-03-31'
            ]
        }
    )


    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "afterDate",
            "values": [
                dateMonthRadio === 'date' ? startDate : '2024-03-31'
            ]
        }
    )


    if (dateMonthRadio === 'date') {
        filters.push(
            {
                "member": "Contribution.Onboarded_date",
                "operator": "beforeDate",
                "values": [
                    endDate
                ]
            }
        )
    }



    if (filters?.length) {
        return { ...marketQueryOnboard, filters };
    }
    return marketQueryOnboard;

}


export const handleStateCaseQuery = (
    name, startDate, endDate, dateMonthRadio
) => {

    let filters = [];
    let tableName = "Contribution";

    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "afterDate",
            "values": [
                dateMonthRadio === 'date' ? startDate : '2024-03-31'
            ]
        }
    )


    if (dateMonthRadio === 'date') {
        filters.push(
            {
                "member": "Contribution.Date",
                "operator": "beforeDate",
                "values": [
                    endDate
                ]
            }
        )
    }

    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "afterDate",
            "values": [
                '2024-03-31'
            ]
        }
    )

    if (filters?.length) {
        return { ...myStateCaseCount, filters };
    }
    return myStateCaseCount;

};



const personQueryOnboard = {
    "measures": [
        "Contribution.client_count"
    ],
    "timeDimensions": [
        {
            "dimension": "Contribution.Date"
        }
    ],
    "order": {
        "Contribution.Onboarded_date": "desc"
    },
    "dimensions": [
        "Contribution.agent_name",
        "Contribution.Onboarded_date"
    ],
}

export const handlePersonQueryOnboard = (startDate, endDate, dateMonthRadio) => {

    let filters = [];
    let tableName = "Contribution";

    filters.push(
        {
            "member": "Contribution.agent_name",
            "operator": "notEquals",
            "values": [
                "no_agent"
            ]
        }
    )

    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "afterDate",
            "values": [
                startDate
            ]
        }
    )

    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "afterDate",
            "values": [
                '2024-03-31'
            ]
        }
    )



    if (dateMonthRadio === 'date') {
        filters.push(
            {
                "member": "Contribution.Onboarded_date",
                "operator": "beforeDate",
                "values": [
                    endDate
                ]
            }
        )
    }


    if (filters?.length) {
        return { ...personQueryOnboard, filters };
    }
    return personQueryOnboard;
}



const personProspectQuery = {
    "order": {
        "m_dashboard.lead_count": "desc"
    },
    "measures": [
        "m_dashboard.lead_count"
    ],
    "timeDimensions": [
        {
            "dimension": "m_dashboard.created_at"
        }
    ],
    "filters": [
        {
            "member": "m_dashboard.source_name",
            "operator": "notEquals",
            "values": [
                "Null",
                "Testing Marcom",
                "Direct Field",
                "Inside sales cold Outreach",
                "Inside Sales Cold Outreach"
            ]
        },
        {
            "member": "m_dashboard.current_stage",
            "operator": "notEquals",
            "values": [
                "Onboarded"
            ]
        }
    ],
    "dimensions": [
        "m_dashboard.source_name"
    ]
}

export const handlePersonProspectQuery = () => {
    return personProspectQuery
}



const personCaseQuery = {
    "timeDimensions": [
        {
            "dimension": "Contribution.Date"
        }
    ],
    "order": {
        "Contribution.total_case_count": "desc"
    },
    "dimensions": [
        "Contribution.agent_name",
        "Contribution.Date"
    ],

    "measures": [
        "Contribution.total_case_count"
    ]
}



export const hanldlePersonCaseQuery = (startDate, endDate, dateMonthRadio) => {

    let filters = [];
    let tableName = "Contribution";

    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "afterDate",
            "values": [
                dateMonthRadio === 'date' ? startDate : '2024-03-31'
            ]
        }
    )

    if (dateMonthRadio === 'date') {
        filters.push(
            {
                "member": "Contribution.Date",
                "operator": "beforeDate",
                "values": [
                    endDate
                ]
            }
        )
    }


    filters.push(
        {
            "member": "Contribution.agent_name",
            "operator": "notEquals",
            "values": [
                "no_agent"
            ]
        }
    )

    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "afterDate",
            "values": [
                "2024-03-31"
            ]
        }
    )


    if (filters?.length) {
        return { ...personCaseQuery, filters };
    }
    return personCaseQuery;

}



const clientLevelCase={
    "measures": [
      "Contribution.total_case_count"
    ],
    "order": {
      "Contribution.total_case_count": "desc"
    },
    "dimensions": [
      "Contribution.agent_name",
      "Contribution.client_fk",
      "Contribution.client_name"
    ],
  }



export const handleQueryMyClientCaseCount = (
    name, date, contribution, modality,teamName
) => {

    let filters = [];
    let tableName = "Contribution";

    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "equals",
            "values": [
                date
            ]
        }
    )



    if (contribution === 'my') {
        filters.push({
            member: tableName + ".agent_name",
            operator: "contains",
            values: [name],
        });
    }

    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "afterDate",
            "values": [
                '2024-03-31'
            ]
        }
    )

    if (modality?.length > 0 && modality?.length <= 3) {
        filters.push({
            member: tableName + ".modality",
            operator: "equals",
            values: modality,
        });
    }

    if(contribution !=='my' && teamName!=='All'){
        filters.push({
            member: tableName + ".agent_name",
            operator: "contains",
            values: [teamName],
        });
    }

    if (filters?.length) {
        return { ...clientLevelCase, filters };
    }
    return myContributionCase;

};